<template>
    <div>
         <v-data-table
            :headers="headers"
            :items="logs"
            :items-per-page="limit"
            :loading="loading"
            loading-text="Loading Data..."
            :page.sync="page"
        >
            <template v-slot:top="{}">
                <div class="d-flex mt-5">
                    <v-text-field
                        prepend-inner-icon="mdi-magnify"
                        v-model="searchPhrase"
                        @input="debouncedSearch"
                        outlined
                        dense
                        hide-details
                        class="mr-4"
                        style="max-width:250px"
                    ></v-text-field>
                    
                    <v-select
                        :items="moduleOptions"
                        item-text="text"
                        item-value="value"
                        dense
                        outlined
                        class="shrink ml-2 wdt"
                        v-model="module"
                        placeholder="Select Module"
                        @change="resetPage"
                    ></v-select>
                    <v-spacer></v-spacer>
                    <v-menu 
                        v-model="adminDateMenu" 
                        :close-on-content-click="false" 
                        transition="scale-transition" 
                        min-width="auto"
                        left 
                        origin="top right"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                v-bind="attrs" 
                                v-on="on" 
                                icon
                            >
                                <v-icon size="40" color="primary">mdi-calendar-month</v-icon>
                            </v-btn>
                        </template>
                        <v-date-picker 
                            v-model="logDates" 
                            range
                            @input="adminDateMenu" 
                            :max="today"
                            :min="logDate3"
                            @change="getLogs"
                        >
                        </v-date-picker>
                    </v-menu>
                    <div class="py-1 ml-5 title">{{ from }} - {{ to }} {{ $t('of') }} {{ totalCount }}</div>
                    <v-btn class="mx-2" fab small outlined color="primary" :disabled="page <= 1"
                        @click="pageChange(false)">
                        <v-icon dark>
                            mdi-chevron-left
                        </v-icon>
                    </v-btn>
                    <v-btn class="mx-2" fab small outlined color="primary" @click="pageChange(true)"
                        :disabled="page >= totalPages">
                        <v-icon dark>
                            mdi-chevron-right
                        </v-icon>
                    </v-btn>
                </div>
            </template>
            <template v-if="logs.length > 0" v-slot:body="{ items }">
                <tbody>
                    <tr
                        v-for="item in items"
                        :key="item.id"
                        style="position: relative; width: 0; height: 0"
                        @mouseover="selectItem(item)"
                        @mouseleave="selectItem(false)"
                    >
                        <td>{{ formatDate(item.createdAt) }}</td>
                        <td>{{ item.user_id || '-' }}</td>
                        <td>{{ userDisplay(item.user) }}</td>
                        <td>{{ item.user ? item.user.role : '-' }}</td>
                        <td>{{ item.ip_address || '-' }}</td>
                        <td>{{ item.activity_table }}</td>
                        <td>{{ item.activity_type }}</td>
                        <template v-if="getModulePermittedActions.get">
                            <div style="position: absolute; right: 10px; top:5px;" v-if="item === selectedItem">  
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn 
                                            x-small 
                                            fab
                                            v-bind="attrs"
                                            v-on="on"
                                            class="green-shadow"
                                            @click="showSingleLogDetails(item)"
                                        >
                                            <v-icon>mdi-eye</v-icon> 
                                        </v-btn>
                                    </template>
                                    <span>{{ $t('logs.view')}}</span>
                                </v-tooltip>
                            </div>
                        </template>
                    </tr>
                </tbody>
            </template>
            <template v-slot:no-data v-if="logs.length < 1">
                NO LOG AVAILABLE
            </template>
            <template v-slot:footer></template>
        </v-data-table>
        <single-log v-if="showSingleLog" :log="sLog" @closeLogModal="closeSingleLog" :dialogU="showSingleLog"></single-log>
    </div>
</template>
<script>
import moment from "moment";
import PermissionsMixin from "@/mixins/PermissionsMixin"
import loadingMixin from "@/mixins/LoadingMixin"
import LogsService from '@/_services/LogsService'
import SingleLog from "./SingleLog.vue"
import getPermittedActions from "@/mixins/GetPermittedActions";

    export default {
        components: {
            SingleLog,
        },
        async created(){
            let date = new Date();
            let firstDayYYYYMMDD = moment(new Date(date.getFullYear(), date.getMonth(), 1)).format("YYYY-MM-DD")
            let todayYYYYMMDD = moment(date).format("YYYY-MM-DD")
            this.logDates = [firstDayYYYYMMDD, todayYYYYMMDD]
            this.getLogs()
        },
        data() {
            return {
                loading: false,
                page: 1,
                logs: [],
                logDates: [],
                searchPhrase: '',
                adminDateMenu: false,
                today: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10),
                logDate: new Date(Date.now() - new Date().getTimezoneOffset() * 60000).toISOString().slice(0, 10),
                logDate3: new Date((Date.now() - new Date().getTimezoneOffset() * 60000) - 7889400000).toISOString().slice(0, 10),
                newLogDate: null,
                module: 'user_activity_log',
                moduleOptions: [
                    { text: 'User Activity Log', value: 'user_activity_log' },
                    { text: 'Farm Activity Log', value: 'farm_activity_log' },
                ],
                limit: 20,
                totalPages: 1,
                selectedItem: false,
                showSingleLog: false,
                sLog: {},
                headers: [
                    { text: this.$t('logs.time'), align: 'start', value: 'createdAt', class: "black--text" },
                    { text: this.$t('logs.userID'), sortable: false, value: 'user_id', class: "black--text" },
                    { text: this.$t('logs.username'), value: 'user.firstName', class: "black--text" },
                    { text: this.$t('logs.role'), value: 'user.role', class: "black--text" },
                    { text: this.$t('logs.terminalID'), sortable: false, value: 'ip_address', class: "black--text" },
                    { text: this.$t('logs.moduleAccessed'), value: 'activity_table', class: "black--text" },
                    { text: this.$t('logs.typeOfAccess'), value: 'activity_type', class: "black--text" },
                ],
                from: 0,
                to: 0,
                totalCount: 0,
            }
        },
        methods: {
            getLogs(){
                this.loading = true;
                const date1 = new Date(this.logDates[0]).getTime();
                const date2 = new Date(this.logDates[1]).getTime();
                let dateDiff, date_1, date_2;
                if (date1 > date2) {
                    dateDiff = date1 - date2;
                    date_1 = this.logDates[1];
                    date_2 = this.logDates[0];
                } else {
                    dateDiff = date2 - date1;
                    date_1 = this.logDates[0];
                    date_2 = this.logDates[1];
                }
                const daydiff = dateDiff / (1000 * 60 * 60 * 24);
                if (daydiff < 1) {
                    this.$notify({ title: "Select one day earlier logs", type: "error" });
                    this.loading = false;
                } else if (daydiff > 92) {
                    this.$notify({ title: "Cannot see logs before 3 months", type: "error" });
                    this.loading = false;
                } else {
                    this.newLogDate = date_1 + "/" + date_2;
                    LogsService.getLogs(this.newLogDate, 'admin', this.module, this.page, this.limit, this.searchPhrase)
                    .then(response => {
                        if (response.success) {
                            this.logs = response.data.logs || [];
                            this.totalCount = response.data.total || 0;
                            this.totalPages = Math.ceil(this.totalCount / this.limit);
                            this.setPages();
                        } else {
                            this.logs = [];
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        this.logs = [];
                        this.loading = false;
                    });
                }
            },
            formatDate(val) {
                return val ? moment(val).format('YYYY-MM-DD HH:mm') : '-'
            },
            userDisplay(user) {
                if (!user) return '-'
                const name = [user.firstName, user.lastName].filter(Boolean).join(' ').trim()
                return name || user.email || user.mobile || '-'
            },
            debouncedSearch() {
                clearTimeout(this._searchTimer)
                this._searchTimer = setTimeout(() => this.resetPage(), 400)
            },
            resetPage() {
                this.page = 1;
                this.getLogs();
            },
            selectItem(item) {
                this.selectedItem = item
            },
            pageChange(t) {
                if (t) this.page++
                else this.page--
                this.getLogs()
            },
            showSingleLogDetails(log) {
                this.sLog = log;
                this.showSingleLog = true;
            },
            closeSingleLog() {
                this.sLog = {}
                this.showSingleLog = false;
            },
            setPages() {
                if (this.logs.length < 1) {
                    this.from = 0;
                    this.to = 0;
                    return;
                }
                this.from = (this.page - 1) * this.limit + 1;
                this.to = (this.page - 1) * this.limit + this.logs.length;
            }
        },
        mixins: [PermissionsMixin, loadingMixin, getPermittedActions]
    }
</script>
